export default __webpack_public_path__ + "static/media/kenji.70fe6853.png";